<form [formGroup]="form" [hidden]="filterVisible === false">
  <div class="d-flex flex-column">
    <div class="filter-row d-flex flex-row justify-end items-start gap-16">
      <formly-form
        [form]="form"
        [fields]="filterFields"
        [model]="formModel"
        class="flex-1"
      ></formly-form>
      @if (!triggerViaChange) {
        <div [style.padding-top.px]="5">
          <button type="submit" mat-raised-button color="accent" (click)="search()">
            <span [innerText]="'crud.applyFilter' | translate"></span>
          </button>
          <button type="button" mat-button color="warn" (click)="resetFilter()">
            <span [innerText]="'crud.resetFilter' | translate"></span>
          </button>
        </div>
      }
    </div>
  </div>
</form>
